import { motion, useInView } from "framer-motion"
import { Link, graphql, useStaticQuery } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"
import ImageOpt from "./ImageOpt"

const ItinerariesListingGrid = ({ module }) => {
  const ref = useRef(null)
  const [hasPlayed, setHasPlayed] = useState(false)
  const isInView = useInView(ref)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        // staggerChildren: 0.2,
      },
    },
  }

  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])

  const itingridData = useStaticQuery(graphql`
    query itingridQuery {
      allWpItineraries(sort: { date: ASC }, limit: 3) {
        nodes {
          title
          excerpt
          uri
          featuredImage {
            node {
              altText
              mediaItemUrl
            }
          }
          itinerariesContent {
            facilities
            gridImage {
              altText
              mediaItemUrl
              title
            }
            stay
          }
        }
      }
    }
  `)
  const allitingriData = itingridData.allWpItineraries.nodes

  if (module.hideSection === "no") {
    return (
      <React.Fragment>
        <motion.section
          initial="hidden"
          animate={isInView || hasPlayed ? "show" : "hidden"}
          variants={sectionShow}
          className={`itineraries-grid py-75 xlscreen:py-50 bg-white-200 relative pattern-zebra ${
            module.extraClass ? ` ${module.extraClass}` : ""
          }`}
          id={module.extraId}
        >
          <motion.div
            ref={ref}
            initial="hidden"
            animate={isInView || hasPlayed ? "show" : "hidden"}
            variants={sectionShow}
            className="container-fluid-sm"
          >
            <div className="max-w-[573px] mx-auto text-center">
              {module?.heading && (
                <motion.div
                  variants={animFade}
                  className="title title-grey grey-separator-both uppercase"
                >
                  <h2>{module.heading}</h2>
                </motion.div>
              )}
              {module?.description && (
                <motion.div variants={animFade} className="content pt-15">
                  <p>{parse(module.description)}</p>
                </motion.div>
              )}
              {module?.button && (
                <motion.div variants={animFade} className="pt-25">
                  <Link
                    to={module.button.url}
                    className="btn btn-grey"
                    target={module.button.target}
                  >
                    {module.button.title}
                  </Link>
                </motion.div>
              )}
            </div>
            <motion.div
              variants={animFade}
              className="itineraries-grid-main grid grid-cols-3 lgscreen:grid-cols-2 mdscreen:grid-cols-1 gap-35 pt-60 xlscreen:pt-45 mdscreen:pt-30"
            >
              {allitingriData.map((item, i) => (
                <div className="items_wrapper" key={i}>
                  <Link to={item.uri} className="relative block">
                    {item.itinerariesContent.gridImage && (
                      <div className="img">
                        <ImageOpt
                          imgData={
                            item.itinerariesContent.gridImage.mediaItemUrl
                          }
                          imgAlt={item.itinerariesContent.gridImage.title}
                          imgClass=""
                          width={600}
                          height={1600}
                          imgLoad="lazy"
                          className="object-cover"
                        />
                      </div>
                    )}
                    <div className="desc absolute top-0 left-0 h-full w-full py-40 px-20">
                      <div className="flex flex-col justify-between items-center h-full">
                        {item.itinerariesContent.stay && (
                          <motion.div
                            variants={animFade}
                            className="pre-heading white w-full text-center"
                          >
                            <span>{item.itinerariesContent.stay}</span>
                          </motion.div>
                        )}
                        <div className="title_wrapper">
                          <motion.div
                            variants={animFade}
                            className="title title-white"
                          >
                            <h5>{item.title}</h5>
                          </motion.div>
                          {item.itinerariesContent.facilities && (
                            <div className="content_wrapper text-center pt-10">
                              <div className="content white max-w-[198px] mx-auto uppercase">
                                <p>{item.itinerariesContent.facilities}</p>
                              </div>
                            </div>
                          )}
                        </div>
                        <motion.div variants={animFade} className="custom-btn">
                          <span className="btn btn-underline-white">
                            view itinerary
                          </span>
                        </motion.div>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </motion.div>
          </motion.div>
        </motion.section>
      </React.Fragment>
    )
  }
}

export default ItinerariesListingGrid
export const PageItinerariesListingGridFragment = graphql`
  fragment PageItinerariesListingGridFragment on WpPage_Pagecontent_PageContent_ItinerariesListingGrid {
    extraClass
    extraId
    hideSection
    description
    button {
      target
      title
      url
    }
    heading
  }
`
